import type { MultilinkStoryblok } from "@/component-types-sb";

export const getUrlFromLinkObject = (
  link?: MultilinkStoryblok
): string | null => {
  if (!link) return null;

  const href =
    link.linktype === "email"
      ? `mailto:${link.email}`
      : link.linktype === "url"
      ? link.cached_url
      : link.anchor
      ? `/${[link.cached_url, link.anchor].join("#")}`
      : link.linktype === "story"
      ? `/${link.cached_url}`
      : "";
  return href || "";
};
